module.exports = __webpack_public_path__ + "img/test.8f47a962.jpg";